import React from "react";
import { NavLink } from "react-router-dom";

const AnimalsList = ({ animalItems, filmId }) => {
    return (
        <aside className="menu">
            <p className="menu-label">Animal</p>
            <ul className="menu-list">
                <li>
                    <NavLink
                        to={`/films/${filmId}/animals/overview`}
                        activeClassName="is-active">
                        Overview
                    </NavLink>
                </li>
                <hr />
                {animalItems?.map((animal, idx) => {
                    return (
                        <li key={idx}>
                            <NavLink
                                to={`/films/${filmId}/animals/${animal.id}/edit`}
                                title={animal.name}
                                activeClassName="is-active"
                                isActive={(match, location) => {
                                    return location.pathname.startsWith(
                                        `/films/${filmId}/animals/${animal.id}`
                                    );
                                }}>
                                {animal.name}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </aside>
    );
};

export default AnimalsList;
